import { Navigate } from 'react-router-dom';
import { Routes } from 'router/routes';
import useUser from 'utils/useUser';

const RootRedirector = () => {
  const { hasHomeDashboardAccess } = useUser();

  if (hasHomeDashboardAccess) {
    return <Navigate to={Routes.homeDashboard} replace />;
  }

  return <Navigate to={Routes.dashboard} replace />;
};

export default RootRedirector;
